import React, { useState } from "react";
import "./Searchjob.css";
import srch from "../../assets/images/srchjob.png";
import Srchjobbanner from "../banners/Srchjobbanner";
import Comming from "../Commingsoon/Comming";

function Serchjob() {
  
  return (
    <div className="srch-job-container">
     <div className="srch-inner">
     <div className="srch-job-content">
        <div className="src-job-text">
          <div className="src-job-text-head">
            Kickstart your career with the right job or Internship
          </div>
          <div className="src-job-text-desc">
            Explore over 5 lakh verified opportunities across top companies and industries—tailored just for students and freshers.
          </div>
          <button onClick={() => window.open("https://risohire.com/", "_blank")} className="srch-job-btn">Search Job</button>
        </div>
        <div className="src-job-img">
          <img src={srch} alt="job" />
        </div>
      </div>
     </div>
      <div className="srch-job-banner">
        <Srchjobbanner />
      </div>

    </div>
  );
}

export default Serchjob;
